import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { BlockBarChartComponent } from '@app/components/blocks/block-barChart/block-barChart.component';
import { BarChartModule } from '@app/components/barChart/barChart.module';

@NgModule({
  imports: [CommonModule, SharedModule, BarChartModule],
  declarations: [BlockBarChartComponent],
  exports: [BlockBarChartComponent],
})
export class BlockBarChartModule {}
